import template from './add_peer_group_and_member.html';
import * as Utils from '../../lib/savanna_utils.js';

class AddPeerGroupViewModel
{
    constructor(dialog)
    {
        this.dialog = dialog;
        this.performance_cycle_id = ko.observable();
        this.date = ko.observable(moment().format('YYYY-MM-DD hh:mm'));
        this.departments = ko.observableArray();
        this.selected_department = ko.observable(null);
        this.companies = ko.observableArray();
        this.selected_company = ko.observable();
        this.title = ko.observable('Add Peer Group');
        this.group_name = ko.observable();
        this.description = ko.observable();
        this.from_date = ko.observable();
        this.to_date = ko.observable();
        this.company_id = ko.observable();
        this.editable = ko.observable(false);
        this.add_peer_now = ko.observable(false);
        this.peer_group_id = ko.observable();

        this.view_date = ko.computed(() => {
            return 'View/Print Date:  ' + this.date();
        });

        this.company_changed = ko.computed(() => {
            if (this.selected_company() === this.company_id())
                return false;
            else
                return true;
        });

        this.selected_company.subscribe((val) => {
            if (this.selected_company())
            {
                // Reset department selection when company changes
                this.selected_department(null);
                this.dialog.updateData();
                this.load_employees();
            }
        });

        this.available_employees = ko.observableArray([]);
        this.peer_group_employees = ko.observableArray([]);
        this.available_employee_names = ko.computed(() => {
            return this.available_employees().map(emp => `${emp.firstname} ${emp.surname}`);
        });
        this.current_group_employees = ko.computed(() => {
            return this.peer_group_employees().map(emp => `${emp.firstname} ${emp.surname}`);
        });
        this.selected_available_employees = ko.observableArray([]);
        this.selected_group_employees = ko.observableArray([]);
        
        // This maps the display name back to the employee object
        this.get_employee_display_name = (display_name) => {
            return this.available_employees().find(emp => 
                `${emp.firstname} ${emp.surname}` === display_name);
        };
        
        // Add computed for displaying add_peer_member section
        this.add_peer_member = ko.computed(() => {
            return this.add_peer_now() || this.editable();
        });
        
        // Add department subscription to load employees when department changes
        this.selected_department.subscribe((val) => {
            if (this.selected_department()) {
                this.load_employees();
            }
        });

        this.all_departments = ko.computed(() => {
            let departments = this.departments().slice(); // Create a copy
            // Add "All Departments" option at the beginning
            departments.unshift({
                department_id: null,
                department: 'All Departments'
            });
            return departments;
        });
    };

    close()
    {
        this.dialog.close();
    }

    btn_add_peers_click()
    {
        if (this.selected_available_employees().length === 0) return;
        
        let selected_employees = this.selected_available_employees().map(name => {
            return this.get_employee_display_name(name);
        }).filter(Boolean);

        this.peer_group_employees.push(...selected_employees);
        
        this.available_employees(this.available_employees().filter(emp => 
            !selected_employees.some(selected => selected.employee_id === emp.employee_id)
        ));
        this.selected_available_employees([]);
    }
    
    btn_remove_peers_click()
    {
        if (this.selected_group_employees().length === 0) return;
        
        let selected_employees = this.selected_group_employees().map(name => {
            // Remove trailing space from the name if any
            let full_name = name.trim();
            return this.peer_group_employees().find(emp => 
                `${emp.firstname} ${emp.surname}` === full_name
            );
        }).filter(Boolean);

        this.available_employees.push(...selected_employees);
        
        this.peer_group_employees(this.peer_group_employees().filter(emp => 
            !selected_employees.some(selected => selected.employee_id === emp.employee_id)
        ));
        this.selected_group_employees([]);
    }

    async load_employees()
{
    try
    {
        let filter_conditions = [{
            field: 'company_id',
            operand: '=',
            value: this.selected_company()
        }];

        // If a specific department is selected (not "All Departments" and not empty), add department filter
        if (this.selected_department() !== null && 
            this.selected_department() !== '' && 
            this.selected_department() !== undefined) {
            filter_conditions.push({
                field: 'department_id',
                operand: '=',
                value: this.selected_department()
            });
        }

        let options = {
            table: 'v_active_employees_department',
            schema: 'savanna',
            limit: 1000000,
            fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'date_started', 'department_id', 'company_id'],
            filter: filter_conditions,
            // Add sorting by firstname and surname
            order: [
                { field: 'firstname', direction: 'asc' },
                { field: 'surname', direction: 'asc' }
            ]
        };

        let res = await Grape.fetches.getJSON('/api/record', options);
        console.log('results', res);
        if (res.status != 'ERROR')
        {
            let current_peer_members = [];
            if (this.editable()) {
                current_peer_members = this.peer_group_employees();
            }

            // Clear available employees
            this.available_employees([]);

            // Filter out employees already in the peer group and sort alphabetically
            let available_employees = res.records.filter(emp => 
                !current_peer_members.some(member => member.employee_id === emp.employee_id)
            ).sort((a, b) => {
                // Sort by firstname first, then surname
                let firstNameCompare = (a.firstname || '').localeCompare(b.firstname || '');
                if (firstNameCompare !== 0) return firstNameCompare;
                return (a.surname || '').localeCompare(b.surname || '');
            });

            // Sort current peer members alphabetically as well
            if (this.editable()) {
                current_peer_members.sort((a, b) => {
                    let firstNameCompare = (a.firstname || '').localeCompare(b.firstname || '');
                    if (firstNameCompare !== 0) return firstNameCompare;
                    return (a.surname || '').localeCompare(b.surname || '');
                });
            }

            // Populate available employees
            this.available_employees(available_employees);

            if (this.editable()) 
                this.peer_group_employees(current_peer_members);
            else
                this.peer_group_employees([]);

            // Clear selections
            this.selected_available_employees([]);
            this.selected_group_employees([]);
        }
        else 
            Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees.' });
    }
    catch (error)
    {
        console.error(error);
        Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees: ' + error.message });
    }
}

    async btn_save_peer_group()
    {
        if (!this.group_name())
        {
            Grape.alerts.alert({ type: 'warning', message: "Peer group name cannot be empty!" });
            return;
        }
        
        if (!this.selected_company())
        {
            Grape.alerts.alert({ type: 'warning', message: "Please select a company!" });
            return;
        }
        

        try
        {
            // Check if we're in edit mode
            let is_editing = this.editable() && this.peer_group_id();
            
            let peer_members = null;
            
            // If editing or add_peer_now is true, include member data
            if (this.editable() || this.add_peer_now())
            {
                peer_members = this.peer_group_employees().map(emp => {
                    return {
                        employee_id: emp.employee_id,
                        // Include peer_group_member_id if it exists (for existing members)
                        peer_group_member_id: emp.peer_member_id || null
                    };
                });
            }
    
            let request_data = {
                peer_group_name: this.group_name(),
                description: this.description(),
                company_id: this.selected_company(),
                department_id: this.selected_department(),
                peer_members: peer_members
            };
            
            // Add peer_group_id if in edit mode
            if (is_editing)
            {
                request_data.peer_group_id = this.peer_group_id();
                request_data.is_update = true;
            }
    
            let res = await Grape.fetches.postJSON('/performance_management/peer/add_peer_group', request_data);
            
            if (res.status === 'OK')
            {
                Grape.alerts.alert({ type: 'success', message: is_editing ? 'Peer group updated successfully!' : 'Peer group saved successfully!' 
                });
                this.dialog.close();
            }
            else 
                Grape.alerts.alert({ type: 'error', message: res.message || 'Failed to save peer group.' });
        }
        catch (error)
        {
            console.error(error);
            Grape.alerts.alert({ type: 'error', message: 'An error occurred: ' + (error.message || error) });
        }
    }
}

class AddPeerGroupPage
{
    constructor(bindings)
    {
        this.viewModel = new AddPeerGroupViewModel(this);
        this.bindings = bindings;
    };

    async init()
    {
        Utils.refresh_data_visible_roles();
        this.viewModel.title('Add Peer Group');

        console.log('bindings:', this.bindings);

        try
        {
            // Load companies
            let res = await Grape.fetches.getJSON('/api/record', {
                table: 'company',
                schema: 'public'
            });
            if (res.status != 'ERROR') 
                this.viewModel.companies(res.records);
        }
        catch (error)
        {
            console.error(error);
            Grape.alerts.alert({ type: 'error', title: 'error', message: 'An error occurred while loading companies' });
        }

        // Check if we're in edit mode (data provided in bindings)
        if (this.bindings && this.bindings.data && this.bindings.data.length > 0)
        {
            let peer_group_data = this.bindings.data[0]; // Use first record for peer group info
            
            console.log('Edit mode data:', peer_group_data);
            
            // Set peer group properties
            this.viewModel.title('Edit Peer Group');
            this.viewModel.peer_group_id(peer_group_data.peer_group_id);
            this.viewModel.group_name(peer_group_data.peer_group_name);
            this.viewModel.description(peer_group_data.description);
            this.viewModel.company_id(peer_group_data.company_id);
            this.viewModel.selected_company(peer_group_data.company_id);
            
            // Load departments based on company first
            await this.updateData();
            
            this.viewModel.selected_department(peer_group_data.department_id);
            
            // Enable edit mode and peer member editing
            this.viewModel.editable(true);
            this.viewModel.add_peer_now(true);
            
            await this.viewModel.load_employees();
            
            // Handle peer members (records after the first one or in a member property)
            if (this.bindings.data.length > 1)
            {
                let peer_members = this.bindings.data.map(member => {
                    // Create an employee object based on the member data
                    let firstname = member.firstname;
                    let surname = member.surname;
                    
                    // If we have full_name but not individual name parts
                    if (member.full_name && (!firstname || !surname))
                    {
                        let nameParts = member.full_name.trim().split(' ');
                        firstname = nameParts[0] || "Unknown";
                        surname = nameParts.length > 1 ? nameParts.slice(1).join(' ') : "";
                    }
                    
                    return {
                        employee_id: member.employee_id,
                        firstname: firstname || "Unknown",
                        surname: surname || "",
                        peer_group_member_id: member.peer_member_id || null,
                        email: member.email || "",
                        id_number: member.id_number || "",
                        date_started: member.date_started || ""
                    };
                });
                
                // Remove members that are already in the peer group from available employees
                this.viewModel.available_employees(
                    this.viewModel.available_employees().filter(emp => 
                        !peer_members.some(member => member.employee_id === emp.employee_id)
                    )
                );
                
                // Add existing members to peer group employees array
                this.viewModel.peer_group_employees(peer_members);
            }
        }
        else
        {
            // New peer group mode
            this.viewModel.editable(false);
            this.viewModel.title('Add Peer Group');
            this.viewModel.add_peer_now(false);
        }
    }

    async updateData()
    {
        if (this.viewModel.selected_company())
        {
            try
            {
                let res = await Grape.fetches.getJSON('/api/record', {
                    table: 'v_department_company',
                    schema: 'savanna',
                    filter: [{
                        field: 'company_id',
                        operand: '=',
                        value: this.viewModel.selected_company()
                    }]
                });
                if (res.status != 'ERROR') 
                    this.viewModel.departments(res.records);
            }
            catch (error)
            {
                console.error(error);
                Grape.alerts.alert({ type: 'error', title: 'error', message: 'An error occurred while loading departments' });
            }
        }
    }

    close()
    {
        // Close dialog method
        if (this.dialog) 
            this.dialog.close();
    }
}

export default {
    name: 'AddPeerGroup',
    dialog_class: AddPeerGroupPage,
    template: template,
    template_filename: 'translation/dialogs/peer_group',
    provider: 'ps'
};